import { orderedPcrsEntries, toPcrsLabel } from "features/cdm/utils/pcrsDetails";

import { DetailItem } from "../DetailItem/DetailItem";
import styles from "./DetailSection.module.css";

export const DetailSection = ({ title, source, order, emptyText }) => {
  const entries = orderedPcrsEntries(source, order);

  return (
    <div className={styles.section}>
      <p className={styles.sectionTitle}>{title}</p>
      {entries.length ? (
        <div className={styles.grid}>
          {entries.map(([key, value]) => (
            <DetailItem
              key={key}
              fieldKey={key}
              label={toPcrsLabel(key)}
              value={value}
            />
          ))}
        </div>
      ) : (
        <p className={styles.empty}>{emptyText}</p>
      )}
    </div>
  );
};